import React, { useState } from "react";
import {
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";

import AppHeader from "../components/AppHeader";
import FourthTree from "../components/FourthTree";
import NotationExcelSheet from "../components/NotationExcelSheet";
import NotationDetailsPanel from "../components/NotationDetailsPanel";
import FifthTree from "../components/FifthTree";

interface TreeNode {
  text: string;
  tag: number;
  color?: string;
  children: TreeNode[];

  wbsNo?: number;
  notationNo?: number;

  notationHead?: number;
  sequence?: number;
  front?: number;
}

const FifthPanel = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const location = useLocation();

  const [projectName, setProjectName] = useState(
    location.state?.projectName ||
      localStorage.getItem("projectName") ||
      ""
  );

  const userName = localStorage.getItem("userName");

  const projectId = Number(id);
  const refresh = 0;

  const [selectedNode, setSelectedNode] =
    useState<TreeNode | null>(null);


    const [selectedNotation, setSelectedNotation] =
  useState<any>(null);

const [showNotationPopup, setShowNotationPopup] =
  useState(false);

  const handleTreeSelect = (node: TreeNode) => {
    console.log("Fifth Panel Selected:", node);
    setSelectedNode(node);

    // Later:
    // FifthAPI.getData(node.wbsNo, node.notationNo);
  };

  return (
    <div
      className="h-screen flex flex-col bg-gray-100"
      style={{
        fontFamily: "'Segoe UI'",
        fontSize: "13px",
        fontWeight: 400,
      }}
    >
      <AppHeader
        title={projectName || id || "Marks Table"}
        userName={userName}
        activeTab="fifth"
        onBack={() => navigate(-1)}
        onHome={() => navigate("/projects")}
        onDashboard={() =>
          navigate(`/project/${id}`, {
            state: { projectName },
          })
        }
        onSecond={() =>
          navigate(`/project/${id}/second`, {
            state: { projectName },
          })
        }
        onThird={() =>
          navigate(`/project/${id}/third`, {
            state: { projectName },
          })
        }
        onFourth={() =>
          navigate(`/project/${id}/fourth`, {
            state: { projectName },
          })
        }
        onFifth={() =>
          navigate(`/project/${id}/fifth`, {
            state: { projectName },
          })
        }
        /* onLogout={() => {
          localStorage.removeItem("token");
          navigate("/login");
        }} */
      /*  onLogout={() => {
  Object.keys(sessionStorage).forEach((key) => {
    if (
      key.startsWith("treeSelection-") ||
      key.startsWith("treeOpenNodes-")
    ) {
      sessionStorage.removeItem(key);
    }
  });

  localStorage.removeItem("token");
  navigate("/login");
}} */
onLogout={() => {
  sessionStorage.clear();

  localStorage.removeItem("token");

  navigate("/login");
}}
        projectId={projectId}
        onProjectUpdated={setProjectName}
      />

      <div className="flex-1 overflow-hidden">
        
        <div
          className="flex h-full w-full overflow-hidden bg-white"
          style={{
            fontFamily: "'Segoe UI'",
            fontSize: "13px",
            fontWeight: 400,
          }}
        >
          {/* Left Panel - 25% */}
          {/* <div className="basis-1/4 shrink-0 border-r border-gray-300 overflow-auto">


  
            <FifthTree
              projectId={projectId}
              refresh={refresh}
              onSelect={handleTreeSelect}
            />
          </div> */}
          <div className="basis-1/4 shrink-0 border-r border-gray-300 flex flex-col">

  <div className="px-4 pt-4 pb-2">
    <h2>Work Breakdown Structure</h2>
  </div>

  <div className="flex-1 overflow-auto">
    <FifthTree
      projectId={projectId}
      refresh={refresh}
      onSelect={handleTreeSelect}
    />
  </div>

</div>

          {/* Right Panel - 75% */}
          <div className="basis-3/4 flex-1 overflow-auto p-3">
            {selectedNode ? (
 /*  <NotationExcelSheet
    selectedWorkTreeNode={selectedNode.wbsNo ?? null}
  /> */
  <NotationExcelSheet
  selectedWorkTreeNode={selectedNode.wbsNo ?? null}
  onNotationSelect={(notation) => {

    setSelectedNotation(notation);

    setShowNotationPopup(true);

  }}
/>
) : (
  <div className="flex items-center justify-center h-full text-gray-500">
    Select a WBS from the tree.
  </div>
)}
          
          {/*  </div>
        </div>
      </div> */}
 
       </div>

      {showNotationPopup && selectedNotation && (

        <div
          className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
        >

          <div
            className="bg-white rounded-lg shadow-2xl relative"
            style={{
              width: "75vw",
              height: "80vh",
            }}
          >

            {/* Close Button */}

            <button
              onClick={() => {

                setShowNotationPopup(false);

                setSelectedNotation(null);

              }}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                zIndex: 1000,
                width: 34,
                height: 34,
                borderRadius: "50%",
                border: "none",
                background: "#ef4444",
                color: "#fff",
                cursor: "pointer",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              ✕
            </button>

            <NotationDetailsPanel
              projectId={projectId}
              selectedNode={selectedNotation}
            />

          </div>

        </div>

      )}

    </div>
  );

    </div>

    </div>
  )
};
  


export default FifthPanel;